import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAllQuarters } from "../../../redux/features/appraisalSlice";
import { useSelector } from "react-redux";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Quarter_Table_Head } from "../../../components/datagrid/appraisal/QuarterTableHead";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { Box } from "@mui/material";
import AddQuarter from "./AddQuarter";

const QuarterLandingView = () => {
  const dispatch = useDispatch();
  const { loading, quarters } = useSelector((state) => state.appraisal);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const data = {
    search: search,
    page: pageNum,
    limit: gridSize,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getAllQuarters(data));
    }
  }, [search, pageNum, gridSize]);

  return (
    <GlobalWrapper
      title={"Tag names"}
      actions={<AddQuarter dispatchParams={data} />}
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Quarter_Table_Head(data)}
          rows={quarters?.data}
          meta={quarters?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default QuarterLandingView;
